export default "__VITE_ASSET__fe906e95__"